<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import ActionMenuDropdown from "@/components/ActionMenu/ActionMenuDropdown.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import TeamDropdown from "@/components/StickyNote/internal/TeamDropdown/TeamDropdown.vue";
import { boardKey } from "@/components/board/injectKeys";
import { injectStrict } from "@/utils/vue";

import { isActionVisible } from "../actions";

const card = injectStrict(cardKey);
const board = injectStrict(boardKey);

const isVisible = computed(() => isActionVisible("team", card, board.value));
</script>

<template>
  <ActionMenuDropdown v-if="isVisible" :action="cardActions.setTeam">
    <TeamDropdown />
  </ActionMenuDropdown>
</template>
